var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 35,
  height: 35,
  fill: "#fff",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 6.4h24v3.2H8zM4.8 14.4H32v3.2H4.8zM0 22.4h32v3.2H0z"
})));
export { SvgMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIHdpZHRoPSIzNSIgaGVpZ2h0PSIzNSIgZmlsbD0id2hpdGUiPjxwYXRoIGQ9Ik04IDYuNGgyNHYzLjJoLTI0di0zLjJ6Ij48L3BhdGg+PHBhdGggZD0iTTQuOCAxNC40aDI3LjJ2My4yaC0yNy4ydi0zLjJ6Ij48L3BhdGg+PHBhdGggZD0iTTAgMjIuNGgzMnYzLjJoLTMydi0zLjJ6Ij48L3BhdGg+PC9zdmc+";